import React from 'react';

import PropTypes from 'prop-types';

import style from './ModalCommon.module.scss';

function ModalCommonFooter({children}) {
  return <div className={style.footer}>{children}</div>;
}

export default ModalCommonFooter;

ModalCommonFooter.propTypes = {
  children: PropTypes.element.isRequired,
};
